export const FileManagerConst = {
    DriveTypeIds: {
        home: 0,
        important: 4,
        share_with_me: 5,
        share_by_me: 5,
    },
    LayoutType: {
        grid: 'grid',
        list: 'list'
    },
    DriveActionType: {
        share: 'share',
        important: 'important',
        unimportant: 'unimportant',
        folder: 'folder',
        file: 'file'
    },
    DriveTitles: {
        my_drive: 'My Drive',
        important: 'Important',
        shared_with_me: 'Shared with me',
        shared_by_me: 'Shared by me'
    }
}
